import BlocTematicDTO from '@data/models/blocks/block-dto';
import ContentDTO from '@data/models/content/content-dto';
import Dexie from 'dexie';

export class SemDB extends Dexie {
  login: Dexie.Table<
    {
      access_token: string;
      user_id: number | string;
      user_role: string;
      user_full_name: string;
      date_login: Date;
    },
    number
  >;
  farmacs: Dexie.Table<ContentDTO, [number, number]>;
  CECOS: Dexie.Table<ContentDTO, [number, number]>;
  SVA: Dexie.Table<ContentDTO, [number, number]>;
  SVB: Dexie.Table<ContentDTO, [number, number]>;
  escales: Dexie.Table<ContentDTO, [number, number]>;
  INT: Dexie.Table<ContentDTO, [number, number]>;
  HNT: Dexie.Table<ContentDTO, [number, number]>;
  procediments: Dexie.Table<ContentDTO, [number, number]>;
  codisActivacio: Dexie.Table<ContentDTO, [number, number]>;
  glossaris: Dexie.Table<ContentDTO, [number, number]>;
  abreviacions: Dexie.Table<ContentDTO, [number, number]>;
  FISTRA: Dexie.Table<ContentDTO, [number, number]>;
  ETICA: Dexie.Table<ContentDTO, [number, number]>;
  LEGAL: Dexie.Table<ContentDTO, [number, number]>;
  BLOCKS: Dexie.Table<BlocTematicDTO, number>;
  repositori: Dexie.Table<ContentDTO, [number, number]>;

  private readonly ACCESS_TOKEN = 'access_token';
  private readonly DATE_LOGIN = 'date_login';
  private readonly USER_ID = 'user_id';
  private readonly USER_ROLE = 'user_role';
  private readonly USER_FULL_NAME = 'user_full_name';

  constructor() {
    super('sem-db');
    //IMPORTANT: change version if any change in this file implies a modification of a table or a change in pk
    this.version(2.8).stores({
      login: `++id, ${this.ACCESS_TOKEN}, ${this.USER_ID}, ${this.USER_ROLE}, ${this.USER_FULL_NAME}, ${this.DATE_LOGIN}`,
      farmacs: `[id+versio]`,
      CECOS: `[id+versio]`,
      SVA: `[id+versio]`,
      SVB: `[id+versio]`,
      escales: `[id+versio]`,
      INT: `[id+versio]`,
      HNT: `[id+versio]`,
      procediments: `[id+versio]`,
      codisActivacio: `[id+versio]`,
      glossaris: `[id+versio]`,
      abreviacions: `[id+versio]`,
      FISTRA: `[id+versio]`,
      ETICA: `[id+versio]`,
      LEGAL: `[id+versio]`,
      BLOCKS: '[id]',
      repositori: `[id+versio]`
    });
    this.login = this.table('login');
    this.farmacs = this.table('farmacs');
    this.CECOS = this.table('CECOS');
    this.SVA = this.table('SVA');
    this.SVB = this.table('SVB');
    this.escales = this.table('escales');
    this.INT = this.table('INT');
    this.HNT = this.table('HNT');
    this.procediments = this.table('procediments');
    this.codisActivacio = this.table('codisActivacio');
    this.glossaris = this.table('glossaris');
    this.abreviacions = this.table('abreviacions');
    this.FISTRA = this.table('FISTRA');
    this.ETICA = this.table('ETICA');
    this.LEGAL = this.table('LEGAL');
    this.BLOCKS = this.table('BLOCKS');
    this.repositori = this.table('repositori');
  }
}
